import type { FetchError } from 'ofetch'

const defaultErrorMessage = 'Произошла неизвестная ошибка.'

export default class ApiErrorHandler {
  public static getMessageFromData (
    data: { errors: [{ detail?: string }] },
    commonErrorMessage: string
  ): string {
    if (data && Array.isArray(data.errors) && data.errors.length && data.errors[0].detail) {
      return data.errors[0].detail
    }

    return commonErrorMessage ?? defaultErrorMessage
  }

  public static handleFetchError (fetchError: FetchError, commonErrorMessage: string): void {
    console.error(fetchError)

    useNuxtApp().$toast.error(
      fetchError.data
        ? this.getMessageFromData(fetchError.data, commonErrorMessage)
        : commonErrorMessage
    )
  }
}
